import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debt-summary',
  templateUrl: './debt-summary.component.html',
  styleUrls: ['./debt-summary.component.scss']
})
export class DebtSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
